module.exports = __webpack_public_path__ + "img/icon-map-pin-2.a0130713.svg";